/**
 * 共享时间格式化工具 — 统一消息相关的时间展示逻辑。
 * MessageView 和 ParseMessageConversation 中都用到类似的时间格式化，
 * 此处集中管理，避免重复实现。
 */

/**
 * 将 Date 格式化为会话列表中显示的时间：
 * - 当天：HH:MM
 * - 7天内：周X
 * - 同年：MM-DD
 * - 跨年：YYYY-MM-DD
 */
export function formatConversationTime(d: Date): string {
  const now = new Date();
  if (d.toDateString() === now.toDateString()) {
    return d.toLocaleTimeString("zh-CN", { hour: "2-digit", minute: "2-digit" });
  }
  const diffDays = Math.floor((now.getTime() - d.getTime()) / (1000 * 60 * 60 * 24));
  if (diffDays < 7) {
    const days = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
    return days[d.getDay()];
  }
  if (d.getFullYear() === now.getFullYear()) {
    return d.toLocaleDateString("zh-CN", { month: "2-digit", day: "2-digit" });
  }
  return d.toLocaleDateString("zh-CN");
}

/**
 * 将 Date 格式化为消息气泡之间的时间分隔符：
 * - 当天：HH:MM
 * - 7天内：周X HH:MM
 * - 同年：MM-DD HH:MM
 * - 跨年：YYYY-MM-DD HH:MM
 */
export function formatSeparatorTime(d: Date): string {
  const now = new Date();
  if (d.toDateString() === now.toDateString()) {
    return d.toLocaleTimeString("zh-CN", { hour: "2-digit", minute: "2-digit" });
  }
  const diffDays = Math.floor((now.getTime() - d.getTime()) / (1000 * 60 * 60 * 24));
  if (diffDays < 7) {
    const days = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
    return (
      days[d.getDay()] +
      " " +
      d.toLocaleTimeString("zh-CN", { hour: "2-digit", minute: "2-digit" })
    );
  }
  if (d.getFullYear() === now.getFullYear()) {
    return (
      d.toLocaleDateString("zh-CN", { month: "2-digit", day: "2-digit" }) +
      " " +
      d.toLocaleTimeString("zh-CN", { hour: "2-digit", minute: "2-digit" })
    );
  }
  return (
    d.toLocaleDateString("zh-CN") +
    " " +
    d.toLocaleTimeString("zh-CN", { hour: "2-digit", minute: "2-digit" })
  );
}

/**
 * 从 ISO 时间字符串创建 Date 对象
 */
export function parseTimeString(s: string | null | undefined): Date | null {
  if (!s) return null;
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
}
